import { render } from "./WhoIsHenry.vue?vue&type=template&id=a3eb634c&scoped=true"
import script from "./WhoIsHenry.vue?vue&type=script&lang=js"
export * from "./WhoIsHenry.vue?vue&type=script&lang=js"

import "./WhoIsHenry.vue?vue&type=style&index=0&id=a3eb634c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3eb634c"]])

export default __exports__